// extracted by mini-css-extract-plugin
export default {"rounded":"RoundedPlusButton_rounded__yB54H","plus":"RoundedPlusButton_plus__74ceR"};